export const PlanType = Object.freeze({
    "Unknown": 0,
    "Medical": 1,
    "Vision": 2,
    "Dental":3,
    "VoluntaryLife":4,
    "BasicLife":5,
    "ShortTermDisability":6,
    "LongTermDisability":7,
    "MedicalCareFsa":8,
    "SpouseLife": 9,
    "ChildLife": 10,
    "DependentCareFsa": 11,
    "BeneficiaryLife": 12
})